import type { ComponentPropsWithoutRef, Ref } from "react";

type NodeDivProps = ComponentPropsWithoutRef<"div"> & {
  nodeRef?: Ref<HTMLDivElement>;
};

// A div that hands its node to `nodeRef`, for TransitionGroup's `component`.
export default function NodeDiv({ nodeRef, ...props }: NodeDivProps) {
  return <div ref={nodeRef} {...props} />;
}
